/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as MyInsightsRouteImport } from './routes/my-insights'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as TeamInsightsRouteImport } from './routes/team-insights'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TeamInsightsIndexRouteImport } from './routes/team-insights/index'
import { Route as TeamInsightsSessionsRouteImport } from './routes/team-insights/sessions'
import { Route as TeamInsightsSystemPerformanceRouteImport } from './routes/team-insights/system-performance'
import { Route as TeamInsightsUtilizationRouteImport } from './routes/team-insights/utilization'
import { Route as TeamInsightsWellnessRouteImport } from './routes/team-insights/wellness'
import { Route as TeamInsightsSessionsSessionSessionTitleRouteImport } from './routes/team-insights/sessions/session.$sessionTitle'
import { Route as TeamInsightsSessionsMonthlyYearMonthRouteImport } from './routes/team-insights/sessions/monthly.$year.$month'

const IndexLazyRouteImport = createFileRoute('/')()
const LoginLazyRouteImport = createFileRoute('/login')()
const PasswordResetLazyRouteImport = createFileRoute('/password-reset')()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginLazyRoute = LoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const MyInsightsRoute = MyInsightsRouteImport.update({
  id: '/my-insights',
  path: '/my-insights',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetLazyRoute = PasswordResetLazyRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/password-reset.lazy').then((d) => d.Route),
)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamInsightsRoute = TeamInsightsRouteImport.update({
  id: '/team-insights',
  path: '/team-insights',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamInsightsIndexRoute = TeamInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TeamInsightsRoute,
} as any)
const TeamInsightsSessionsRoute = TeamInsightsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => TeamInsightsRoute,
} as any)
const TeamInsightsSystemPerformanceRoute =
  TeamInsightsSystemPerformanceRouteImport.update({
    id: '/system-performance',
    path: '/system-performance',
    getParentRoute: () => TeamInsightsRoute,
  } as any)
const TeamInsightsUtilizationRoute = TeamInsightsUtilizationRouteImport.update({
  id: '/utilization',
  path: '/utilization',
  getParentRoute: () => TeamInsightsRoute,
} as any)
const TeamInsightsWellnessRoute = TeamInsightsWellnessRouteImport.update({
  id: '/wellness',
  path: '/wellness',
  getParentRoute: () => TeamInsightsRoute,
} as any)
const TeamInsightsSessionsSessionSessionTitleRoute =
  TeamInsightsSessionsSessionSessionTitleRouteImport.update({
    id: '/session/$sessionTitle',
    path: '/session/$sessionTitle',
    getParentRoute: () => TeamInsightsSessionsRoute,
  } as any).lazy(() =>
    import('./routes/team-insights/sessions/session.$sessionTitle.lazy').then(
      (d) => d.Route,
    ),
  )
const TeamInsightsSessionsMonthlyYearMonthRoute =
  TeamInsightsSessionsMonthlyYearMonthRouteImport.update({
    id: '/monthly/$year/$month',
    path: '/monthly/$year/$month',
    getParentRoute: () => TeamInsightsSessionsRoute,
  } as any).lazy(() =>
    import('./routes/team-insights/sessions/monthly.$year.$month.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/crm': typeof CrmRoute
  '/my-insights': typeof MyInsightsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRoute
  '/team-insights': typeof TeamInsightsRouteWithChildren
  '/terms-of-service': typeof TermsOfServiceRoute
  '/login': typeof LoginLazyRoute
  '/password-reset': typeof PasswordResetLazyRoute
  '/team-insights/sessions': typeof TeamInsightsSessionsRouteWithChildren
  '/team-insights/system-performance': typeof TeamInsightsSystemPerformanceRoute
  '/team-insights/utilization': typeof TeamInsightsUtilizationRoute
  '/team-insights/wellness': typeof TeamInsightsWellnessRoute
  '/team-insights/': typeof TeamInsightsIndexRoute
  '/team-insights/sessions/session/$sessionTitle': typeof TeamInsightsSessionsSessionSessionTitleRoute
  '/team-insights/sessions/monthly/$year/$month': typeof TeamInsightsSessionsMonthlyYearMonthRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/crm': typeof CrmRoute
  '/my-insights': typeof MyInsightsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/login': typeof LoginLazyRoute
  '/password-reset': typeof PasswordResetLazyRoute
  '/team-insights/sessions': typeof TeamInsightsSessionsRouteWithChildren
  '/team-insights/system-performance': typeof TeamInsightsSystemPerformanceRoute
  '/team-insights/utilization': typeof TeamInsightsUtilizationRoute
  '/team-insights/wellness': typeof TeamInsightsWellnessRoute
  '/team-insights': typeof TeamInsightsIndexRoute
  '/team-insights/sessions/session/$sessionTitle': typeof TeamInsightsSessionsSessionSessionTitleRoute
  '/team-insights/sessions/monthly/$year/$month': typeof TeamInsightsSessionsMonthlyYearMonthRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminRoute
  '/analytics': typeof AnalyticsRoute
  '/crm': typeof CrmRoute
  '/my-insights': typeof MyInsightsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/profile': typeof ProfileRoute
  '/team-insights': typeof TeamInsightsRouteWithChildren
  '/terms-of-service': typeof TermsOfServiceRoute
  '/login': typeof LoginLazyRoute
  '/password-reset': typeof PasswordResetLazyRoute
  '/team-insights/sessions': typeof TeamInsightsSessionsRouteWithChildren
  '/team-insights/system-performance': typeof TeamInsightsSystemPerformanceRoute
  '/team-insights/utilization': typeof TeamInsightsUtilizationRoute
  '/team-insights/wellness': typeof TeamInsightsWellnessRoute
  '/team-insights/': typeof TeamInsightsIndexRoute
  '/team-insights/sessions/session/$sessionTitle': typeof TeamInsightsSessionsSessionSessionTitleRoute
  '/team-insights/sessions/monthly/$year/$month': typeof TeamInsightsSessionsMonthlyYearMonthRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/analytics'
    | '/crm'
    | '/my-insights'
    | '/privacy-policy'
    | '/profile'
    | '/team-insights'
    | '/terms-of-service'
    | '/login'
    | '/password-reset'
    | '/team-insights/sessions'
    | '/team-insights/system-performance'
    | '/team-insights/utilization'
    | '/team-insights/wellness'
    | '/team-insights/'
    | '/team-insights/sessions/session/$sessionTitle'
    | '/team-insights/sessions/monthly/$year/$month'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/analytics'
    | '/crm'
    | '/my-insights'
    | '/privacy-policy'
    | '/profile'
    | '/terms-of-service'
    | '/login'
    | '/password-reset'
    | '/team-insights/sessions'
    | '/team-insights/system-performance'
    | '/team-insights/utilization'
    | '/team-insights/wellness'
    | '/team-insights'
    | '/team-insights/sessions/session/$sessionTitle'
    | '/team-insights/sessions/monthly/$year/$month'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/analytics'
    | '/crm'
    | '/my-insights'
    | '/privacy-policy'
    | '/profile'
    | '/team-insights'
    | '/terms-of-service'
    | '/login'
    | '/password-reset'
    | '/team-insights/sessions'
    | '/team-insights/system-performance'
    | '/team-insights/utilization'
    | '/team-insights/wellness'
    | '/team-insights/'
    | '/team-insights/sessions/session/$sessionTitle'
    | '/team-insights/sessions/monthly/$year/$month'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AdminRoute: typeof AdminRoute
  AnalyticsRoute: typeof AnalyticsRoute
  CrmRoute: typeof CrmRoute
  MyInsightsRoute: typeof MyInsightsRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  ProfileRoute: typeof ProfileRoute
  TeamInsightsRoute: typeof TeamInsightsRouteWithChildren
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  LoginLazyRoute: typeof LoginLazyRoute
  PasswordResetLazyRoute: typeof PasswordResetLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-insights': {
      id: '/my-insights'
      path: '/my-insights'
      fullPath: '/my-insights'
      preLoaderRoute: typeof MyInsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset': {
      id: '/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PasswordResetLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-insights': {
      id: '/team-insights'
      path: '/team-insights'
      fullPath: '/team-insights'
      preLoaderRoute: typeof TeamInsightsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team-insights/': {
      id: '/team-insights/'
      path: '/'
      fullPath: '/team-insights/'
      preLoaderRoute: typeof TeamInsightsIndexRouteImport
      parentRoute: typeof TeamInsightsRoute
    }
    '/team-insights/sessions': {
      id: '/team-insights/sessions'
      path: '/sessions'
      fullPath: '/team-insights/sessions'
      preLoaderRoute: typeof TeamInsightsSessionsRouteImport
      parentRoute: typeof TeamInsightsRoute
    }
    '/team-insights/system-performance': {
      id: '/team-insights/system-performance'
      path: '/system-performance'
      fullPath: '/team-insights/system-performance'
      preLoaderRoute: typeof TeamInsightsSystemPerformanceRouteImport
      parentRoute: typeof TeamInsightsRoute
    }
    '/team-insights/utilization': {
      id: '/team-insights/utilization'
      path: '/utilization'
      fullPath: '/team-insights/utilization'
      preLoaderRoute: typeof TeamInsightsUtilizationRouteImport
      parentRoute: typeof TeamInsightsRoute
    }
    '/team-insights/wellness': {
      id: '/team-insights/wellness'
      path: '/wellness'
      fullPath: '/team-insights/wellness'
      preLoaderRoute: typeof TeamInsightsWellnessRouteImport
      parentRoute: typeof TeamInsightsRoute
    }
    '/team-insights/sessions/session/$sessionTitle': {
      id: '/team-insights/sessions/session/$sessionTitle'
      path: '/session/$sessionTitle'
      fullPath: '/team-insights/sessions/session/$sessionTitle'
      preLoaderRoute: typeof TeamInsightsSessionsSessionSessionTitleRouteImport
      parentRoute: typeof TeamInsightsSessionsRoute
    }
    '/team-insights/sessions/monthly/$year/$month': {
      id: '/team-insights/sessions/monthly/$year/$month'
      path: '/monthly/$year/$month'
      fullPath: '/team-insights/sessions/monthly/$year/$month'
      preLoaderRoute: typeof TeamInsightsSessionsMonthlyYearMonthRouteImport
      parentRoute: typeof TeamInsightsSessionsRoute
    }
  }
}

interface TeamInsightsSessionsRouteChildren {
  TeamInsightsSessionsSessionSessionTitleRoute: typeof TeamInsightsSessionsSessionSessionTitleRoute
  TeamInsightsSessionsMonthlyYearMonthRoute: typeof TeamInsightsSessionsMonthlyYearMonthRoute
}

const TeamInsightsSessionsRouteChildren: TeamInsightsSessionsRouteChildren = {
  TeamInsightsSessionsSessionSessionTitleRoute:
    TeamInsightsSessionsSessionSessionTitleRoute,
  TeamInsightsSessionsMonthlyYearMonthRoute:
    TeamInsightsSessionsMonthlyYearMonthRoute,
}

const TeamInsightsSessionsRouteWithChildren =
  TeamInsightsSessionsRoute._addFileChildren(TeamInsightsSessionsRouteChildren)

interface TeamInsightsRouteChildren {
  TeamInsightsSessionsRoute: typeof TeamInsightsSessionsRouteWithChildren
  TeamInsightsSystemPerformanceRoute: typeof TeamInsightsSystemPerformanceRoute
  TeamInsightsUtilizationRoute: typeof TeamInsightsUtilizationRoute
  TeamInsightsWellnessRoute: typeof TeamInsightsWellnessRoute
  TeamInsightsIndexRoute: typeof TeamInsightsIndexRoute
}

const TeamInsightsRouteChildren: TeamInsightsRouteChildren = {
  TeamInsightsSessionsRoute: TeamInsightsSessionsRouteWithChildren,
  TeamInsightsSystemPerformanceRoute: TeamInsightsSystemPerformanceRoute,
  TeamInsightsUtilizationRoute: TeamInsightsUtilizationRoute,
  TeamInsightsWellnessRoute: TeamInsightsWellnessRoute,
  TeamInsightsIndexRoute: TeamInsightsIndexRoute,
}

const TeamInsightsRouteWithChildren = TeamInsightsRoute._addFileChildren(
  TeamInsightsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AdminRoute: AdminRoute,
  AnalyticsRoute: AnalyticsRoute,
  CrmRoute: CrmRoute,
  MyInsightsRoute: MyInsightsRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  ProfileRoute: ProfileRoute,
  TeamInsightsRoute: TeamInsightsRouteWithChildren,
  TermsOfServiceRoute: TermsOfServiceRoute,
  LoginLazyRoute: LoginLazyRoute,
  PasswordResetLazyRoute: PasswordResetLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
